var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Status } from '@philips-internal/oswald-ui-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isEnumValid, isValidWidth } from '@philips-internal/oswald-ui-utils';
import { CardMode, CardType } from '../card/card-constants.js';
class AvatarCardAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
    }
    getType() {
        return this.state.type;
    }
    setType(type) {
        if (!isEnumValid(CardType, type))
            return;
        this.setState({ type });
    }
    getTitle() {
        return this.state.title;
    }
    setTitle(title) {
        this.setState({ title });
    }
    getSubtitle() {
        return this.state.subtitle;
    }
    setSubtitle(subtitle) {
        this.setState({ subtitle });
    }
    isSubtitlesHiddenOnMobile() {
        return this.state.subtitleHiddenOnMobile;
    }
    setSubtitlesHiddenOnMobile(subtitleHiddenOnMobile) {
        this.setState({ subtitleHiddenOnMobile });
    }
    getImage() {
        return this.state.image;
    }
    setImage(image) {
        this.setState({ image });
    }
    getStatus() {
        return this.state.status;
    }
    setStatus(status) {
        if (!isEnumValid(Status, status))
            return;
        this.setState({ status });
    }
    getStampLabel() {
        return this.state.stampLabel;
    }
    setStampLabel(stampLabel) {
        this.setState({ stampLabel });
    }
    getStampIcon() {
        return this.state.stampIcon;
    }
    setStampIcon(stampIcon) {
        this.setState({ stampIcon });
    }
    isStampVisible() {
        return this.state.stampVisible;
    }
    setStampVisible(stampVisible) {
        this.setState({ stampVisible });
    }
    getColor() {
        return this.state.color;
    }
    setColor(color) {
        this.setState({ color });
    }
    isDateVisible() {
        return this.state.dateVisible;
    }
    setDateVisible(dateVisible) {
        this.setState({ dateVisible });
    }
    getMode() {
        return this.state.mode;
    }
    setMode(mode) {
        if (!isEnumValid(CardMode, mode))
            return;
        this.setState({ mode });
    }
    getWidth() {
        return this.state.width;
    }
    setWidth(width) {
        if (isValidWidth(width)) {
            this.setState({ width });
        }
    }
    getDate() {
        return this.state.date;
    }
    setDate(date) {
        this.setState({ date });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AvatarCardAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AvatarCardAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AvatarCardAPI.prototype, "onContextMenuClick", void 0);
export default AvatarCardAPI;
//# sourceMappingURL=avatar-card-api.js.map